import { Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { CircularLoading } from "../../../components/common";
import { oids } from "../../../configs/Settings";
import { useSessionContext } from "../../../contexts/SessionContext";
import { GetSchedule, PatchSchedule } from "../../../services/fhir";
import { AppointmentAccordion } from "../../schedulemanager/components/AppointmentAccordion";

interface IProps {
  locationId: any;
  setDisabled: any;
}

export function ManageInativateSchedule({ locationId, setDisabled }: IProps) {
  const [schedule, setSchedule] = useState<fhir5.BundleEntry<fhir5.Schedule>[]>(
    []
  );
  const [loading, setLoading] = useState(true);
  const { access, user } = useSessionContext();
  const [refetch, setRefetch] = useState<boolean>(false);
  const [activeSchedule, setActiveSchedules] = useState<[]>([]);

  useEffect(() => {
    async function fetchSchedules() {
      setLoading(true);
      const auxActor =
        !access?.roles?.includes("manager") && `Location/${locationId}`;
      const bundleEntry: fhir5.BundleEntry<fhir5.Schedule>[] = [];
      Promise.all([
        GetSchedule({
          active: true,
          organization: `${oids.cnpj}-${access.organizationId}`,
          ...(auxActor && { actor: auxActor }),
        }).then((response: fhir5.Bundle<fhir5.Schedule>) => {
          if (response?.entry) {
            bundleEntry.push(...response.entry);
          }
        }),
      ]).then(() => {
        setSchedule(bundleEntry);

        const displaySchedules = bundleEntry?.filter((el: any) => {
          return el?.resource?.actor?.some((actor: any) =>
            actor?.reference?.endsWith(locationId)
          );
        });
        if (!displaySchedules?.length) setDisabled(false);
        setSchedule(displaySchedules);
        setLoading(false);
      });
    }
    fetchSchedules();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetch, access?.roles, user.username]);

  const idSchedule = schedule?.map((el: any) => el?.resource?.id);

  const onSubmit = async (idSchedules: string[]) => {
    const patchOperation = [
      {
        op: "replace",
        path: "/active",
        value: "false",
      },
    ];

    try {
      setLoading(true);
      await Promise.all(
        idSchedules.map((id) => PatchSchedule(id, patchOperation))
      );
      toast.success("Agenda(s) cancelada(s) com sucesso!");
      setRefetch(!refetch); // Refetch schedules after successful patch
      setDisabled(false);
    } catch (err) {
      toast.error("Não foi possível cancelar a(s) agenda(s)");
      console.log("err:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <CircularLoading />
      ) : (
        <>
          {schedule?.length ? (
            <>
              <Typography
                variant="subtitle2"
                fontWeight="400"
                color="neutral700.main"
                textAlign="center"
                m={{ xs: 2, md: 5 }}
              >
                Esta localização possui as seguintes agendas ativas:
              </Typography>
              {schedule?.map((element: any, index: number) => (
                <AppointmentAccordion
                  key={index}
                  defaultOpen={index === 0}
                  setRefetch={setRefetch}
                  schedule={element}
                  activeSchedule={activeSchedule}
                  setActiveSchedules={setActiveSchedules}
                  id={element?.resource?.id}
                />
              ))}

              <Button
                variant="text"
                sx={{
                  textTransform: "none",
                  width: "fit-content",
                  padding: "8px",
                  alignSelf: "center",
                }}
                onClick={() => onSubmit(idSchedule)}
              >
                <Typography variant="subtitle2" fontWeight="400">
                  Ok, cancelar agendas!
                </Typography>
              </Button>
            </>
          ) : (
            <>
              <Typography
                variant="subtitle2"
                fontWeight="400"
                color="neutral700.main"
                textAlign="center"
                m={{ xs: 2, md: 5 }}
              >
                Esta localização não possui agendas ativas!
              </Typography>
            </>
          )}
        </>
      )}
    </>
  );
} 